import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '../../../atoms';
import classes from './StageElements.module.scss';

type BookFirstAppointmentProps = {
  requiresFirstAppointment?: boolean;
};

export const BookFirstAppointment = ({ requiresFirstAppointment }: BookFirstAppointmentProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={classes.CircleWithIcon}>
        <Icon icon='calendarWithDays' size={70} color={'white'} />
        <div className={classes.CircleText}>
          Erstgespräch
          <br />
          buchen
        </div>
      </div>
      <div className={classes.DescriptionSection}>
        <div className={classes.DescriptionTitle}>Erstgespräch buchen</div>
        {requiresFirstAppointment === true && (
          <div className={classes.DescriptionText}>
            Ihr letzter Termin liegt länger als 365 Tage zurück. Bitte buchen Sie erneut ein Erstgespräch.
          </div>
        )}
        <div className={classes.DescriptionText}>
          Buchen Sie jetzt Ihren Termin für Ihr Erstgespräch. Dieses kann in einem unserer Therapiezentren oder online
          stattfinden.
        </div>
        <div className={classes.ActionButtons}>
          <Button onClick={() => navigate('/profile/appointment-choice')}>Jetzt Termin buchen</Button>
        </div>
      </div>
    </>
  );
};
